export const hoursOptions: {
  value: number;
}[] = [{ value: 6 }, { value: 12 }, { value: 24 }, { value: 48 }, { value: 72 }, { value: 168 }, { value: 336 }, { value: 720 }, { value: 1440 }, { value: 2160 }];
